// Angular
import { Component, Input, OnInit,ChangeDetectorRef } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { ActivatedRoute, Router } from '@angular/router';
import{CommonService}from '../../../../../Service/common/common-service.service';
import {environment} from '../../../../../../environments/environment';
import { Ba1110ChangeComponent } from '../../../../pages/Hrms/ba1110/Change/ba1110-change.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator } from "@angular/material";
// import { Adm000Service } from 'src/app/core/_base/_service/adm000.service';
import { Adm000Service } from '../../../../../core/_base/_service/adm000.service';

@Component({
	selector: 'kt-user-profile',
	templateUrl: './user-profile.component.html',
})
export class UserProfileComponent implements OnInit {
	// Public properties
	user$!: Observable<any>;

	lblCompName!: string;
	lblLoginUserName!: string;
	lblPhoto!: string;
	lblSwitchToErp!: string;
	lblSwitchToMyPortal!: string;
	lblSwitchToMyPortalFlag!: string;

	@Input() avatar = true;
	@Input() greeting = true;
	@Input() badge!: boolean;
	@Input() icon!: boolean;

	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(private store: Store<AppState>,private router: Router,private dialog: MatDialog, private objCommonService:CommonService,
		 private changeDetectorRef: ChangeDetectorRef,private authService:Adm000Service) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init 
	 */
	ngOnInit(): void {

		this.objCommonService.ReadLoginuserName().subscribe(data=>{

			if(data.LoginCompNam) this.lblCompName = data.LoginCompCod + ' - ' + data.LoginCompNam;
			// this.lblLoginUserName = data.LoginEmpNam;

			if (data.LoginEmpNam == "" || data.LoginEmpNam == null) {
            const currentUserItem = localStorage.getItem('currentUser');
            if (currentUserItem) {
                const userLoginDetails = JSON.parse(currentUserItem);
                this.lblLoginUserName = userLoginDetails.EmpNam;
            }
        } else {
            this.lblLoginUserName = data.LoginEmpNam;
        }
 

			if(data.EmployeePhotoPath != ""){
				this.lblPhoto = environment.baseUrl.replace("api/", "") + data.EmployeePhotoPath;
			}
			else{
				this.lblPhoto = environment.baseUrl.replace("api/", "") + "UploadFiles/DocManager/Default/photo.png";
			}

const divErp = document.getElementById('divErp');
if (divErp && divErp.style) {
	divErp.style.display = 'none';
}
const divEss = document.getElementById('divEss');
if (divEss && divEss.style) {
	divEss.style.display = 'none';
}

if (data.EssPermission == 1 && data.LoginPortalUser == 0) {
	if (divEss && divEss.style) {
		divEss.style.display = 'block';
	}
} else if (data.ErpPermission == 1 && data.LoginPortalUser == 1) {
	if (divErp && divErp.style) {
		divErp.style.display = 'block';
	}
}

			this.changeDetectorRef.detectChanges();
			})
 
			//this.lblLoginUserName = "Muller"
			this.lblSwitchToErp = "Switch to Unisis Hrms"
			this.lblSwitchToMyPortal= "Switch to Employee Service Portal"
			this.lblSwitchToMyPortalFlag= "1"
	}

	/**
	 * Log out
	 */
	logout() {
		//this.store.dispatch(new Logout());

		this.objCommonService.Logout().subscribe(data=>{
			// clear stored session + ensure UI resets to LTR
			localStorage.clear();
			if (document && document.documentElement) {
				document.documentElement.dir = 'ltr';
			}
			const htmlTag = document.getElementById('htmlDirection');
			if (htmlTag) {
				htmlTag.setAttribute('dir', 'ltr');
				htmlTag.style.direction = 'ltr';
			}
               
			this.router.navigate(['/auth/login']);	
		})
	}

	SwitchUserType(PortalUser: any)
	{
		this.objCommonService.SwitchUserType(PortalUser).subscribe(data=>{
			localStorage.clear();
			localStorage.setItem('currentUser', JSON.stringify(data));
			localStorage.setItem('LanguageId', JSON.stringify(data.LanguageId));
			localStorage.setItem('PortalUser', JSON.stringify(data.PortalUser));
			//window.location.href='/#/dashboard';
			//window.location.reload();
			//window.location.href='/dashboard';
			window.location.href='/#/widget/widget-dashboard/3';
			window.location.reload();
		})
	}

	SwitchUser(){
		if(	this.lblSwitchToMyPortalFlag == "1")
		{
			this.lblSwitchToMyPortal= "Switch to My Portal"
			this.lblSwitchToMyPortalFlag= "2"
		}
		else {
			this.lblSwitchToMyPortal= "Switch to ERP"
			this.lblSwitchToMyPortalFlag= "1"
		}
	}

	changePassword(data: any) {
  this.dialog.open(Ba1110ChangeComponent, {
    width: '500px',
    maxWidth: '95vw',
    maxHeight: '90vh',  
    autoFocus: false,
    disableClose: false,
    data: {
      userName: this.lblLoginUserName
    }
  });
}


}
